import { ArrowUpRight, MessageCircle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { whatsappUrl } from "@/lib/whatsapp";
import Reveal from "@/components/Reveal";

const ClosingCta = ({ onQuote }) => {
  const { t } = useLanguage();

  return (
    <section className="relative overflow-hidden py-28 lg:py-40" data-testid="closing-cta-section">
      <div className="grid-bg absolute inset-0 opacity-70" />
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-cy/10 blur-[160px]" />
      <div className="relative mx-auto max-w-5xl px-4 text-center sm:px-6">
        <Reveal>
          <h2 className="font-display text-3xl font-extrabold leading-[1.1] tracking-tight text-slate-50 sm:text-5xl lg:text-6xl">
            {t.closing.title1}
            <span className="block text-cy text-glow">{t.closing.title2}</span>
          </h2>
          <p className="mx-auto mt-8 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">{t.closing.sub}</p>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
            <button
              data-testid="closing-quote-btn"
              onClick={onQuote}
              className="group flex items-center gap-2 rounded-full bg-cy px-8 py-4 font-display text-base font-bold text-ink transition-all duration-300 hover:bg-em hover:shadow-[0_0_40px_rgba(0,240,255,0.45)]"
            >
              {t.closing.primary}
              <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </button>
            <a
              data-testid="closing-whatsapp-btn"
              href={whatsappUrl(t.whatsapp.message)}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 rounded-full border border-em/40 px-8 py-4 font-display text-base font-semibold text-em transition-all duration-300 hover:bg-em/10"
            >
              <MessageCircle className="h-5 w-5" />
              {t.closing.secondary}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ClosingCta;
